import { StyleSheet, Image, Text, View, Button } from "react-native";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import { Entypo } from "@expo/vector-icons";
import { Ionicons } from "@expo/vector-icons";
import BookCard from "../BookCard";
import { useEffect, useRef, useState } from "react";
import { Picker } from "@react-native-picker/picker";
import cover from "../../assets/bookcover.png";
import { SafeAreaView } from "react-native";
import { StatusBar } from "react-native";

const SomaliBooklet = (props) => {

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar
        barStyle="light-content"
        hidden={false}
        backgroundColor="#192655"
        translucent={false}
        networkActivityIndicatorVisible={true}
        animated={true}
      />
      <View style={styles.header}>
        <TouchableOpacity onPress={() => props.navigation.goBack()}>
          <Entypo name="chevron-left" color="#fff" size={25} />
        </TouchableOpacity>
      </View>
      <View style={styles.cont}>
        <Text
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#fff",
            marginTop: 20,
          }}
        >
          Books
        </Text>
      </View>
      <View style={{ flex: 1, flexDirection: "row" }}>
        <ScrollView style={{ marginTop: 40, paddingVertical: 50 }}>
          <View
            style={{
              flex: 1,
              flexDirection: "column",
              justifyContent: "flex-end",
              paddingHorizontal:40
            }}
          >
          </View>
        </ScrollView>
      <ScrollView style={{ marginTop: 40 }}>
        <BookCard
          onPress={() => props.navigation.navigate("SomaliPage")}
          img={cover}
          title="Buug yar oo ku saabsan dhicida aan
          kutalogalka aheyn, sida looga hortago iyo
          daaweynta isbitaalka kahor caruurta dugsiga."
          read="Aqri"
          bg="#5272F2"
        />
        
      </ScrollView>
      </View>
    </SafeAreaView>
  );
};

export default SomaliBooklet;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#192655",
    // width: "100%",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    paddingHorizontal: 20,
    paddingTop: 20,
  },
});
